<template>
  <div class="header">
    <el-card shadow="hover" style="margin-bottom: 10px">
      <el-row class="flex-header">
        <div class="input-right">
          <label>商品名称：</label>
          <el-input
            :value="keyword"
            @input="$emit('input', $event, 'keyword')"
            class="input"
            clearable
            placeholder="商品名称"
          ></el-input>
        </div>
        <div class="input-right">
          <label>商品分类：</label>
          <el-select
            class="input"
            :value="productCategoryId"
            @change="$emit('input', $event, 'productCategoryId')"
            placeholder="商品分类"
          >
            <el-option
              v-for="item in category"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>

        <div class="input-right">
          <label>销量：</label>
          <el-input
            type="tel"
            class="input-num"
            :value="minSale"
            :max="maxSale"
            @input="$emit('input', $event, 'minSale')"
          ></el-input>
          <span class="input-line">——</span>
          <el-input
            type="tel"
            class="input-num"
            :value="maxSale"
            @input="$emit('input', $event, 'maxSale')"
          ></el-input>
        </div>

        <div class="input-right">
          <label>价格：</label>
          <el-input
            type="tel"
            class="input-num"
            :value="minPrice"
            :max="maxPrice"
            @input="$emit('input', $event, 'minPrice')"
          >
            <span slot="suffix" class="input-suffix">元</span>
          </el-input>
          <span class="input-line">——</span>
          <el-input
            type="tel"
            class="input-num"
            :value="maxPrice"
            @input="$emit('input', $event, 'maxPrice')"
          >
            <span slot="suffix" class="input-suffix">元</span>
          </el-input>
        </div>
      </el-row>
      <el-row class="input-bottom">
        <el-button type="primary" @click="$emit('search')">搜索</el-button>
        <el-button type="plain" @click="$emit('download')">导出</el-button>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
import copy from "@/utils/deepCopy";

export default {
  props: {
    keyword: {
      type: String,
    },
    maxPrice: {
      type: String,
    },
    minPrice: {
      type: String,
    },
    maxSale: {
      type: String,
    },
    minSale: {
      type: String,
    },
    classifyList: {
      type: Array,
    },
    publishStatus: {
      type: Number | String,
    },
    productCategoryId: {
      type: Number | String,
    },
  },
  watch: {
    classifyList(val) {
      this.category = copy(val);
      this.category.unshift({ id: 0, name: "全部" });
    },
  },
  mixins: [tablePagination, loading],
  data() {
    return {
      tableData: [],
      category: [],
    };
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped src="../style.scss">
</style>